"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jwt_decode_1 = __importDefault(require("jwt-decode"));
class AuthenticatedUser {
    static factory(jwtToken = '') {
        try {
            AuthenticatedUser.token = jwtToken;
            return new AuthenticatedUser((0, jwt_decode_1.default)(jwtToken));
        }
        catch (_) {
            return null;
        }
    }
    constructor({ id, iri, email, permissions, customer, department, departmentDeep, exp, isActive, defaultAddressId, favoriteCustomerIds }) {
        this.id = id;
        this.iri = iri;
        this.email = email;
        this.permissions = permissions;
        this.customer = customer;
        this.department = department;
        this.departmentDeep = departmentDeep;
        this.exp = exp;
        this.isActive = isActive;
        this.defaultAddressId = defaultAddressId;
        this.favoriteCustomerIds = favoriteCustomerIds;
    }
    static getToken() {
        return AuthenticatedUser.token;
    }
    hasPermission(permission) {
        if (!Array.isArray(this.permissions)) {
            return false;
        }
        return this.permissions.includes(permission);
    }
}
exports.default = AuthenticatedUser;
